import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Grid,
  Box,
  TextField,
  Typography,
  Button,
  Stepper,
  Step,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputAdornment,
  IconButton,
} from '@mui/material';
import logoIcon from '../../../../assets/common-assets/docu-transcribe-logo(1).png';
import Visibility from '../../../../assets/common-assets/eye.svg';
import VisibilityOff from '../../../../assets/common-assets/eye-off.svg';
import {
  getHelperText,
  INVALID_INPUT_REGEX,
  REGISTER,
} from '../../../../constants/staticContent';
import { REGISTER_TOAST } from '../../../../constants/toastConstant';
import { classes } from './utils';
import { lightPalette } from '../../../../theme';

import CountryDropdown from '../../account-settings/CountryDropdown';
import CustomTooltip from '../../utils/CustomTooltip';
import Toast from '../../utils/Toast';
import { REGISTER_TOOLTIP } from '../../../../constants/tooltipConstant';

const LastStepRegistration = ({
  formData,
  setFormData,
  errors,
  setErrors,
  prevStep,
  step,
  submitForm,
  isChecked,
  setIsChecked,
  countryValid,
  setCountryValid,
  countryList,
  setCountryList,
  token,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // const [isPopupOpen, setIsPopupOpen] = useState(false);

  // const handleTogglePopup = () => {
  //   setIsPopupOpen(!isPopupOpen);
  // };
  const handleRedirectToTermsOfService = () => {
    window.open(
      'https://dtdemo.aspiresoftware.in/terms-of-service/',
      '_blank',
      'noopener,noreferrer',
    );
  };
  const handleRedirectToPrivacyPolicy = () => {
    window.open(
      'https://dtdemo.aspiresoftware.in/privacy-policy/',
      '_blank',
      'noopener,noreferrer',
    );
  };
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);
  const validatePassword = (password) => {
    const passwordRegex = INVALID_INPUT_REGEX.PASSWORD;
    return passwordRegex.test(password);
  };

  const validateCountry = (value) => {
    if (!value) {
      setCountryValid(false);
      return false;
    }
    setCountryValid(true);
    return true;
  };
  const validateEmptyField = (password) => password !== '';
  const organizationRegex = INVALID_INPUT_REGEX.ORGANIZATION;
  const validateOrganizationField = (organization) =>
    !organizationRegex.test(organization);
  const referredByRegex = INVALID_INPUT_REGEX.REFERRAL_CODE;
  const validateReferredByField = (referralCodeBy) =>
    referredByRegex.test(referralCodeBy);
  const newConfirmSimilarity = (newPass, confirmPass) =>
    newPass === confirmPass;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
      country: countryList?.label,
    }));

    if (name === 'password') {
      const isValid = validatePassword(value);
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: !isValid,
      }));
    } else if (name === 'confirmPassword') {
      const isValid = value === formData.password;
      setErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: !isValid,
      }));
    } else if (name === 'organizationName') {
      const isValid = validateOrganizationField(value);
      setErrors((prevErrors) => ({
        ...prevErrors,
        organizationName: !isValid,
      }));
    } else if (name === 'referralCodeBy') {
      const isValid =
        !token && name === 'referralCodeBy'
          ? validateReferredByField(value)
          : true;
      setErrors((prevErrors) => ({
        ...prevErrors,
        referralCodeBy: !isValid,
      }));
    } else if (name === 'country') {
      const isValid = validateCountry(value);
      setErrors((prevErrors) => ({
        ...prevErrors,
        country: !isValid,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const passwordValid = validatePassword(formData.password);
    const confirmPasswordValid = validateEmptyField(formData.confirmPassword);
    const organizationNameValid = validateOrganizationField(
      formData.organizationName,
    );

    const referredByValid = !token
      ? validateReferredByField(formData.referralCodeBy)
      : true;

    const similarityValid = newConfirmSimilarity(
      formData.password,
      formData.confirmPassword,
    );

    const countryValidate = validateCountry(countryList?.label);

    setErrors({
      password: !passwordValid,
      confirmPassword: !similarityValid,
      country: !countryValidate,
      organizationName: !organizationNameValid,
      referralCodeBy: !referredByValid,
    });
    if (!isChecked) {
      Toast({ message: REGISTER_TOAST.TERM_AND_CONDITION, variant: 'warning' });
      return;
    }
    if (
      passwordValid &&
      confirmPasswordValid &&
      organizationNameValid &&
      referredByValid &&
      countryValidate &&
      isChecked &&
      similarityValid
    ) {
      submitForm();
    }
  };

  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={6.5}
      lg={7.5}
      className={classes.rightGridForBothStep}
    >
      <Box className={classes.rightGridMainBoxForBothStep}>
        <Box
          className={classes.logoBox}
          component="img"
          src={logoIcon}
          alt="logoIcon"
        />

        <Box
          component="form"
          onSubmit={handleSubmit}
          className={classes.submitButton}
        >
          <FormControl className={classes.formControl}>
            <TextField
              className={classes.formCommonTextfieldStepTwo}
              label={REGISTER.TEXTFIELD_STEP_TWO.PASSWORD}
              id="password"
              name="password"
              autoComplete="password"
              autoFocus
              onChange={handleInputChange}
              value={formData.password}
              error={errors.password}
              helperText={getHelperText(
                'password',
                'password',
                errors,
                formData,
              )}
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {showPassword ? (
                        <Box
                          component="img"
                          className={classes.eyeIconForPassword}
                          src={Visibility}
                          alt="EyeOnIcon"
                        />
                      ) : (
                        <Box
                          component="img"
                          className={classes.eyeIconForPassword}
                          src={VisibilityOff}
                          alt="EyeOffIcon"
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              className={classes.formCommonTextfieldStepTwo}
              label={REGISTER.TEXTFIELD_STEP_TWO.CONFIRM_PASSWORD}
              id="confirmPassword"
              name="confirmPassword"
              autoComplete="confirmPassword"
              onChange={handleInputChange}
              value={formData.confirmPassword}
              error={errors.confirmPassword}
              helperText={getHelperText(
                'confirmPassword',
                'confirmPassword',
                errors,
                formData,
              )}
              type={showConfirmPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowConfirmPassword}
                      edge="end"
                    >
                      {showConfirmPassword ? (
                        <Box
                          component="img"
                          className={classes.eyeIconForPassword}
                          src={Visibility}
                          alt="EyeOnIcon"
                        />
                      ) : (
                        <Box
                          component="img"
                          className={classes.eyeIconForPassword}
                          src={VisibilityOff}
                          alt="EyeOffIcon"
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              className={classes.formCommonTextfieldStepTwo}
              label={REGISTER.TEXTFIELD_STEP_TWO.ORGANIZATION_NAME}
              id="organizationName"
              name="organizationName"
              autoComplete="organizationName"
              onChange={handleInputChange}
              value={formData.organizationName}
              error={errors.organizationName}
              helperText={getHelperText(
                'organizationName',
                'organizationName',
                errors,
                formData,
              )}
            />
            {token ? (
              <TextField
                className={classes.formAllTextFieldStepOne}
                disabled
                // required
                id="referralCodeBy"
                label={REGISTER.TEXTFIELD_STEP_TWO.REFERRED_CODE}
                name="referralCodeBy"
                autoComplete="referralCodeBy"
                variant="filled"
                InputProps={{
                  readOnly: true,
                }}
                value={formData.referralCodeBy}
              />
            ) : (
              <TextField
                className={classes.formCommonTextfieldStepTwo}
                label={`${REGISTER.TEXTFIELD_STEP_TWO.REFERRED_CODE} (Optional)`}
                id="referralCodeBy"
                name="referralCodeBy"
                autoComplete="referralCodeBy"
                onChange={handleInputChange}
                value={formData.referralCodeBy}
                error={errors.referralCodeBy}
                helperText={getHelperText(
                  'referralCodeBy',
                  'referralCodeBy',
                  errors,
                  formData,
                )}
              />
            )}
            <FormControl
              className={classes.formSelectionDropdownStepTwo}
              error={errors.country}
            >
              <CountryDropdown
                countryList={countryList}
                setCountryList={setCountryList}
                countryValid={countryValid}
                setCountryValid={setCountryValid}
                setFormData={setFormData}
              />
            </FormControl>
            <Box className={classes.termsOfServiceAndPrivacyPolicyBox}>
              <FormControlLabel
                control={
                  <Checkbox
                    value="accepted&c"
                    checked={isChecked}
                    onChange={(e) => setIsChecked(e.target.checked)}
                    className={classes.checkBox}
                  />
                }
                label={
                  <Typography
                    variant="body2"
                    color={lightPalette.shoeWax.semiLight}
                  >
                    {REGISTER.TERMS_OF_SERVICE_AND_PRIVACY_POLICY.TEXT1}
                    <Link
                      className={classes.termsOfServiceLink}
                      onClick={handleRedirectToTermsOfService}
                    >
                      {REGISTER.TERMS_OF_SERVICE_AND_PRIVACY_POLICY.LINK1}
                    </Link>

                    {REGISTER.TERMS_OF_SERVICE_AND_PRIVACY_POLICY.TEXT2}
                    <Link
                      className={classes.termsOfServiceLink}
                      onClick={handleRedirectToPrivacyPolicy}
                    >
                      {REGISTER.TERMS_OF_SERVICE_AND_PRIVACY_POLICY.LINK2}
                    </Link>
                  </Typography>
                }
              />
            </Box>
            <Button
              type="submit"
              variant="contained"
              className={classes.createAccountButtonStepTwo}
            >
              <Typography variant="h5">
                {REGISTER.CREATE_ACCOUNT_BUTTON}
              </Typography>
            </Button>
            <Typography className={classes.registerTypo} variant="body1">
              {REGISTER.LOGIN_LINK.TEXT}

              <Link to="/login" className={classes.loginLink}>
                {REGISTER.LOGIN_LINK.LINK}
              </Link>
            </Typography>
            <Box className={classes.stepperBox}>
              <Stepper step={step} connector={null}>
                <CustomTooltip title={REGISTER_TOOLTIP.STEPPER}>
                  <Step
                    onClick={prevStep}
                    className={classes.firstStepper}
                    sx={{
                      backgroundColor:
                        step === 1
                          ? lightPalette.primary.main
                          : lightPalette.lunarBase.semiDark,
                    }}
                  />
                </CustomTooltip>
                <Step
                  className={classes.lastStepper}
                  sx={{
                    backgroundColor:
                      step === 2
                        ? lightPalette.primary.main
                        : lightPalette.lunarBase.semiDark,
                  }}
                />
              </Stepper>
            </Box>
          </FormControl>
        </Box>
      </Box>
    </Grid>
  );
};

LastStepRegistration.propTypes = {
  formData: PropTypes.shape({
    password: PropTypes.string,
    confirmPassword: PropTypes.string,
    organizationName: PropTypes.string,
    country: PropTypes.string,
    referralCodeBy: PropTypes.string,
  }).isRequired,
  setFormData: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    password: PropTypes.bool,
    confirmPassword: PropTypes.bool,
    organizationName: PropTypes.bool,
    country: PropTypes.bool,
    referralCodeBy: PropTypes.bool,
  }).isRequired,
  setErrors: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  submitForm: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  setIsChecked: PropTypes.func.isRequired,
  countryList: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  setCountryList: PropTypes.func.isRequired,
  countryValid: PropTypes.bool.isRequired,
  setCountryValid: PropTypes.func.isRequired,
  token: PropTypes.string,
};
LastStepRegistration.defaultProps = {
  token: null,
};
export default LastStepRegistration;
